import Button from '@mui/material/Button';
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import VideoOutlinedIcon from '@mui/icons-material/VideocamOutlined';

export const FormUploadButton = (props: any) => {
  const { children, ...restProps } = props;
  return (
    <Button size="large" startIcon={<AddPhotoAlternateOutlinedIcon />} {...restProps}>
      <span>{children}</span>
    </Button>
  );
};

export const FormRecordButton = (props: any) => {
  const { children, ...restProps } = props;
  return (
    <Button size="large" startIcon={<VideoOutlinedIcon />} {...restProps}>
      <span>{children}</span>
    </Button>
  );
};
